import { Injectable } from '@angular/core';
import { CONSTANTS } from 'src/app/dataModels/constants';
import { CONFIG } from 'src/app/dataModels/config';
import { UserService } from '../user/user.service';
import { ApiService } from '../api/api.service';
import { lastValueFrom } from 'rxjs';

/**
 * Service to provide LOV's and HRCHY's to the components
 */
@Injectable({
  providedIn: 'root',
})
export class ResourceManagerService {
  /**
   * Constructor to inject dependency
   * @param userService instance of userService
   * @param apiService instance of apiService
   */
  constructor(private userService: UserService, private apiService: ApiService) { }


  async getResourcesForReminderCall(resourceList) {
    const response = {} as any;
    const request = { lovList: [] };
    const resources = this.userService.getResources();
    //TBD replace with resources once available
    if (resources) {
      for (const resource of resourceList) {
        if (resource.isReload || !resources[resource.key]) {
          request.lovList.push(resource);
        } else {
          response[resource.key] = resources[resource.key];
        }
      }
    }
    if (request.lovList.length > 0) {
      const result = await lastValueFrom(this.apiService.msPost(CONFIG.MS_GET_GLOBAL_BUNDLE, request, true));
      if (result && result.status === CONSTANTS.SUCCESS && (result.json || result.objects)) {
        if (result.objects) {
          for (const resultObj of result.objects) {
            if (resultObj.name) {
              response[resultObj.name] = resultObj.objects;
            }
          }
        }
        if (result.json) {
          for (const resultObj of result.json) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
      }
    }
    return await this.filterResource(resourceList, response);
  }

  async getResourcesObjects(resourceList) {
    const response = {} as any;
    const request = { objects: [] };
    const resources = this.userService.getResources();
    //TBD replace with resources once available
    if (resources) {
      for (const resource of resourceList) {
        if (resource.isReload || !resources[resource.key]) {
          request.objects.push({
            name: 'GET_LOVS',
            params: {
              key: resource.key,
              activeFlag: 'ALL',
              reload: 'true'
            }
          });
        } else {
          response[resource.key] = resources[resource.key];
        }
      }
    }
    if (request.objects.length > 0) {
      const result = await lastValueFrom(this.apiService.msPost(CONFIG.GET_GLOBAL_BUNDLE, request, true));
      if (result && result.status === CONSTANTS.SUCCESS && (result.json || result.objects)) {
        if (result.objects) {
          for (const resultObj of result.objects) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
        if (result.json) {
          for (const resultObj of result.json) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
      }
    }
    return await this.filterResource(resourceList, response);
  }

  /** core appp */

  async getResourcesCoreApp(resourceList) {
    const response = {} as any;
    const request = { objects: [] };
    const resources = this.userService.getResources();
    //TBD replace with resources once available
    if (resources) {
      if(resourceList.length > 0) {

      
      for (const resource of resourceList) {
        if (resource.isReload || !resources[resource.key]) {
          if (resource.type === CONSTANTS.LOV) {
            request.objects.push({
              name: 'GET_LOVS',
              params: {
                key: resource.key,
                activeFlag: 'ALL',
                reload: 'true'
              }
            });
          } else if (resource.type === CONSTANTS.HRCHY) {
            request.objects.push({
              name: 'GET_HIERARCHY',
              params: {
                key: resource.key,
                reload: 'true'
              }
            });
          }

        } else {
          response[resource.key] = resources[resource.key];
        }
      } } else {
        response[resourceList.key] = resources[resourceList.key];
      }

    }
    if (request.objects.length > 0) {
      const result = await lastValueFrom(this.apiService.post(CONFIG.GET_CORE_GLOBAL_BUNDLE, request, true));
      if (result && result.status === CONSTANTS.SUCCESS && (result.json || result.objects)) {
        if (result.objects) {
          for (const resultObj of result.objects) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
        if (result.json) {
          for (const resultObj of result.json) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
      }
    }
    return await this.filterResource(resourceList, response);
  }

  /**
   * get resources from the session data
   * if isReload is true, then make api call
   * @param resourceList list of resources required by the component
   */
  async getResources(resourceList) {
    const response = {} as any;
    const request = { lovList: [] };
    const resources = this.userService.getResources();
    //TBD replace with resources once available
    if (resources) {
      for (const resource of resourceList) {
        if (resource.isReload || !resources[resource.key]) {
          request.lovList.push(resource);
        } else {
          response[resource.key] = resources[resource.key];
        }
      }
    }
    if (request.lovList.length > 0) {
      const result = await lastValueFrom(this.apiService.msPost(CONFIG.GET_GLOBAL_BUNDLE, request, true));
      if (result && result.status === CONSTANTS.SUCCESS && (result.json || result.objects)) {
        if (result.objects) {
          for (const resultObj of result.objects) {
            if (resultObj.name) {
              response[resultObj.name] = resultObj.objects;
            }
          }
        }
        if (result.json) {
          for (const resultObj of result.json) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
      }
    }
    return await this.filterResource(resourceList, response);
  }
  /**
    * get resources from the session data
    * if isReload is true, then make api call
    * resourceBundle is past as multiple namespaces exists for LOV's
    * @param resourceList list of resources required by the component
    */
  async getMSResources(resourceList, resourceBundle) {
    const response = {} as any;
    const request = { lovList: [] };
    const globalMSContext = CONFIG.MS_GET_GLOBAL_BUNDLE;
    const facNSContext = CONFIG.GET_MS_FACILITY_BUNDLE;
    const heirContext = CONFIG.GET_MS_HIERARCHY;
    const requestObjects = { objects: [] };
    var requestKeyOnly;
    var requestResolved;
    const resources = this.userService.getResources();
    //TBD replace with resources once available
    if (resources) {
      if (resourceBundle === heirContext) {
        requestKeyOnly = resourceList;
      } else {
        for (const resource of resourceList) {
          if (resource.isReload || !resources[resource.key]) {
            if (resourceBundle === globalMSContext) {
              request.lovList.push(resource);
            } else {
              requestObjects.objects.push(resource);
            }
          } else {
            response[resource.key] = resources[resource.key];
          }
        }
      }
    }
    requestResolved = "";
    if (requestObjects.objects.length > 0) {
      requestResolved = requestObjects;
    } else if (request.lovList.length > 0) {
      requestResolved = request;
    } else if (requestKeyOnly) {
      requestResolved = requestKeyOnly;
    }
    if (requestResolved) {
      const result = await lastValueFrom(this.apiService.msPost(resourceBundle, requestResolved, true));
      if (result && result.status === CONSTANTS.SUCCESS) {
        if (result.objects) {
          for (const resultObj of result.objects) {
            if (resultObj.name) {
              response[resultObj.name] = resultObj.json;
            }
          }
        }
        if (result?.json && typeof result.json[Symbol.iterator] === 'function') {
          response.json = result?.json;
          for (const resultObj of result?.json) {
            if (resultObj.key) {
              response[resultObj.key] = resultObj.json;
            }
          }
        }
        if (result?.json && typeof result.json[Symbol.iterator] != 'function') {
          response.json = result?.json;
          if (result?.key) {
            response[result?.key] = response.json;
          }
        }

      }
    }
    /*if (request.lovList.length > 0) { // This is an lov filter non active check
      return await this.filterResource(resourceList, response);
    } else {
      return response;
    }*/
      return await this.filterResource(resourceList, response);
  }
  /**
   * form the request object
   * @param resource reosurce type
   */
  formRequestObj(resource) {
    const nameOfObj = resource.type === CONSTANTS.LOV ? 'GET_LOVS' : 'GET_HIERARCHY';
    return {
      name: nameOfObj,
      params: {
        key: resource.key,
        reload: 'true',
      },
    };
  }

  /**
   * filter the resource based on active flag
   * if active flag is not ALL, then filter all Inactive resource items
   * i.e. Items with Active Flag 'Y' will be available for the components
   * @param resourceList resource list
   * @param responseData response
   */
  filterResource(resourceList, responseData) {
    let newResource:any = {};
    if (resourceList && resourceList.length > 0 && responseData && Object.keys(responseData).length === resourceList.length) {
      resourceList.forEach((resource) => {
        const resourceTemp = resource.key ? responseData[resource.key] : responseData[resource.name];
        if (resource.type === CONSTANTS.LOV) {
          const activeFlag = resource.activeFlag ? resource.activeFlag : 'Y';
          const filterData = [];
          if (activeFlag !== 'ALL') {
            for (const tempResource of resourceTemp) {
              if (tempResource.activeFlag && tempResource.activeFlag === activeFlag) {
                filterData.push(tempResource);
              }
            }
            newResource[resource.key] = filterData;
          } else {
            newResource[resource.key] = resourceTemp;
          }
        } else {
          newResource[resource.key ? resource.key: resource.name] = resourceTemp;
        }
      });
    } else {
      newResource = responseData;
    }

    return newResource;
  }

  /**
   * get LOV resource property
   * @param key LOV
   * @param lovColumnVal columnValue
   * @param propertyToReturn name of property to be returned
   * @param propertyToCheck name of property to check against, default is 'columnValue'
   */
  getLovColumnProperties(key, lovColumnVal, propertyToReturn, propertyToCheck = 'columnValue') {
    const resources = this.userService.getResources();
    let result = '';
    if (resources) {
      const lovList = resources[key];

      result = this.getLovProperty(lovList, propertyToCheck, lovColumnVal, propertyToReturn);
    } else {
      result = '';
    }
    return result;
  }

  getLovColumnPropertiesForm(key, lovColumnVal, propertyToReturn, stateList, propertyToCheck = 'columnValue') {
    //console.log("key: " + key + "  lovColumnVal: " + lovColumnVal + "  propertyToReturn " + propertyToReturn + " columnValue  " + propertyToCheck)
      const lovList = stateList;
      let result = '';
      result = this.getLovProperty(lovList, propertyToCheck, lovColumnVal, propertyToReturn);
      return result
  }
  

  /**
   * get lov property
   * @param lovList list of values
   * @param propertyToCheck indicate which property has to be checked in the array
   * @param lovColumnVal value to be checked with
   * @param propertyToReturn property to be returned
   */
  getLovProperty(lovList, propertyToCheck, lovColumnVal, propertyToReturn) {
    let result = '';
    if (lovList) {
      for (const lov of lovList) {
        if (lov[propertyToCheck].toUpperCase() === lovColumnVal?.toUpperCase()) {
          result = lov[propertyToReturn];
        }
      }
    }
    return result;
  }

  /**
   * get LOV Item for the lovColumnValue
   * @param key LOV
   * @param lovColumnVal LOV columnValue
   * @param propertyToCheck name of property to check against, default is 'columnValue'
   */
  getLovItem(key, lovColumnVal, propertyToCheck = 'columnValue'): any {
    let result = '';

    const resources = this.userService.getResources();

    const lovList = resources[key];

    if (lovList) {
      for (const lov of lovList) {
        if (lov[propertyToCheck].toUpperCase() === lovColumnVal.toUpperCase()) {
          result = lov;
        }
      }
    }

    return result;
  }

  /**
   * Get the array from HRCHY based on the lovColumnValue
   * From the array return the property
   * @param hrchyKey HRCHY Key
   * @param lovColumnValue Lov column value
   */
  getLovBasedOnHeirarchy(hrchyKey, parentLovColumnValue, lovColumnVal, propertyToReturn, propertyToCheck = 'columnValue') {
    let result = '';

    const resources = this.userService.getResources();

    let lovList = [];

    const hrchyList = resources[hrchyKey];

    for (const prop in hrchyList) {
      if (hrchyList.hasOwnProperty(prop)) {
        if (prop === parentLovColumnValue) {
          lovList = hrchyList[prop];
        }
      }
    }

    result = this.getLovProperty(lovList, propertyToCheck, lovColumnVal, propertyToReturn);

    return result;
  }

  getLovBasedOnHierarchyApi(hrchyKey, parentLovColumnValue, lovColumnVal, propertyToReturn, propertyToCheck = 'columnValue') {
    let result = '';

    const resources = this.userService.getResources();

    let lovList = [];
    const request =
    {
      "key": hrchyKey
    };

    this.getMSResources(request, CONFIG.MS_GET_HIERARCHY).then((response) => {
      const hrchyList = response.json;
      for (const prop in hrchyList) {
        if (hrchyList.hasOwnProperty(prop)) {
          if (prop === parentLovColumnValue) {
            lovList = hrchyList[prop];
          }
        }
      }
      result = this.getLovProperty(lovList, propertyToCheck, lovColumnVal, propertyToReturn);
    });

    return result;
  }
}
